<Boundary>
  <div class="yinzcam-ad-slot" class:display-none={!loadedAd}>
    {#if loadedAd}
    <ButtonParticle {...adButtonProps} />
    {/if}
  </div>
</Boundary>

<style>
  *, *::after, *::before {
    box-sizing: border-box;
  }
  .yinzcam-ad-slot {
    width: 100%;
    text-align: center;
  }

  .yinzcam-ad-slot :global(a) {
    display: inline;
  }</style>

<script context="module" lang="ts">var _a;
const adSelectionTracker = {};
function selectAd(slotId, formFactor, ads) {
    var _a;
    //return _.sample(ads);
    let slotRec = adSelectionTracker[slotId];
    if (!slotRec) {
        slotRec = adSelectionTracker[slotId] = {};
    }
    let tracker = slotRec[formFactor];
    if (!tracker) {
        tracker = slotRec[formFactor] = {};
    }
    const currentAds = {};
    for (let ad of ads) {
        if (!(ad === null || ad === void 0 ? void 0 : ad.id) || currentAds[ad.id]) {
            continue;
        }
        if (!(ad.id in tracker)) {
            tracker[ad.id] = false;
        }
        currentAds[ad.id] = ad;
    }
    for (let adId of Object.keys(tracker)) {
        if (!(adId in currentAds)) {
            delete tracker[adId];
        }
    }
    let statuses = Object.entries(tracker);
    if (statuses.length === 0) {
        return null;
    }
    let adId = (_a = statuses.find(([_, v]) => !v)) === null || _a === void 0 ? void 0 : _a[0];
    if (!adId) {
        statuses.forEach(([k, _]) => tracker[k] = false);
        adId = statuses[0][0];
    }
    else {
        tracker[adId] = true;
    }
    // console.log('SELECT AD', slotId, formFactor, adId, tracker, currentAds);
    return currentAds[adId];
}
</script>

<script lang="ts">var _a;
import { Boundary } from '@crownframework/svelte-error-boundary/src/index';
import "yinzcam-cards";
import { writable } from "svelte/store";
import ROOT from '../../../../../../inversify.config';
import { getToken } from 'inversify-token';
import { YinzCamAdsServerToken } from 'yinzcam-ads';
import 'yinzcam-api';
import _ from 'lodash';
import { CardsPageContextKey } from 'components/cards/common/context';
import { getContext } from 'svelte';
import { ButtonParticle, ButtonParticleSpec } from 'components/cards/particles/YinzCam';
export let element;
//export let sources: Readable<CardsDataSourceRegistration[]>;
//export const defaultSourceClasses = [ 'YinzCamAdsServerBannerAds' ]
//export let sourceStore: Readable<any>
const pageContext = getContext(CardsPageContextKey);
const adsResponseStore = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.slotId) ?
    getToken(ROOT, YinzCamAdsServerToken).getAds(element.data.slotId, null, element.data.formFactor || null).store :
    writable(null);
let loadedAd = false;
let adId = null;
let adButtonProps = ButtonParticleSpec.propsWithDefaults({ showText: false, image: { role: 'general', _nolazy: true } });
function loadAds(rsp) {
    const elData = element.data;
    if (rsp.isStatusNot2xx) {
        console.error(`YinzCamAdSlot: unable to load ads data for major=${elData.slotId} ff=${elData.formFactor} -- status code ${rsp.status}`);
        return;
    }
    const rspData = rsp === null || rsp === void 0 ? void 0 : rsp.data;
    const ads = rspData === null || rspData === void 0 ? void 0 : rspData.ads;
    if (!_.isArray(ads)) {
        console.error(`YinzCamAdSlot: unable to load ads data for major=${elData.slotId} ff=${elData.formFactor} -- ads array not found`);
        return;
    }
    // pick a random ad and show it!
    const ad = selectAd(element.data.slotId, element.data.formFactor, ads);
    if (!ad) {
        console.error(`YinzCamAdSlot: unable to load ads data for major=${elData.slotId} ff=${elData.formFactor} -- ad not found`);
        return;
    }
    adButtonProps.image.source = ad.image_url;
    adButtonProps.link = ad.clickthrough_url;
    loadedAd = true;
    adId = ad.id;
    pageContext.getAnalytics().sendInteractionEvent('adImpression', adId);
}
$: if ($adsResponseStore && !loadedAd) {
    //console.log('ADS DATA!!!', $adsData);
    loadAds($adsResponseStore);
}
function handleClick() {
    pageContext.getAnalytics().sendInteractionEvent('adClickthrough', adId);
}
// TODO: Support data sources
//$: { sourceStore = getFirstSourceStore($sources) }
//$: data = sourceStore ? $sourceStore : {}
// $: console.log('YinzCamAdSlot Data', data);
</script>
